<template>
    <div>
        <ValidationObserver ref="updateFormValidate">
            <h6>{{ $t('personal_info') }}</h6>
            <div class="border p-4 rounded-sm mb-3">
                <b-row>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('national_id')">
                            <ValidationProvider name="national_id" rules="required" v-slot="{ errors }">
                                <b-form-input v-model="formData.national_id"
                                              :state="errors[0] ? false : null" :disabled="true" />
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('name')">
                            <ValidationProvider name="name" rules="required" v-slot="{ errors }">
                                <b-form-input v-model="formData.name"
                                              :state="errors[0] ? false : null"
                                              :disabled="true"/>
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('surname')">
                            <ValidationProvider name="surname" rules="required" v-slot="{ errors }">
                                <b-form-input v-model="formData.surname"
                                              :state="errors[0] ? false : null"
                                              :disabled="true"/>
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <ValidationProvider name="birthdate" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('birthdate')">
                                <select-date v-model="formData.birthdate" :validationError="errors[0]" :disabled="true" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('gsm_no')">
                            <ValidationProvider name="phone" rules="required" v-slot="{ errors }">
                                <b-form-input v-model="formData.phone"
                                              v-mask="'### ### ## ##'"
                                              :state="errors[0] ? false : null"
                                              :disabled="!updateMode"/>
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('email')">
                            <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                                <b-form-input v-model="formData.email"
                                              :state="errors[0] ? false : null"
                                              :disabled="!updateMode"/>
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <ValidationProvider name="city" rules="" v-slot="{ errors }">
                            <b-form-group :label="$t('city')">
                                <city-selectbox v-model="formData.city_id"
                                                :validateError="errors[0]"
                                                :disabled="!updateMode"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <ValidationProvider name="district" rules="" v-slot="{ errors }">
                            <b-form-group :label="$t('district')">
                                <district-outline-selectbox v-model="formData.district_id"
                                                            :city_id="formData.city_id"
                                                            :validateError="errors[0]"
                                                            :disabled="!updateMode"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="12" lg="12">
                        <ValidationProvider name="address" rules="" v-slot="{ errors }">
                            <b-form-group :label="$t('address')">
                                <b-form-textarea v-model="formData.address" rows="3"
                                                 :state="errors[0] ? false : null"
                                                 :disabled="!updateMode"/>
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>
            </div>
            <h6>{{ $t('education_info') }}</h6>
            <div class="border p-4 rounded-sm mb-3">
                <b-row>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('high_school_name')">
                            <ValidationProvider name="school_name" rules="" v-slot="{ errors }">
                                <b-form-input v-model="formData.school"
                                              :state="errors[0] ? false : null" />
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <ValidationProvider name="highschool_city" rules="" v-slot="{ errors }">
                            <b-form-group :label="$t('city')">
                                <city-selectbox v-model="formData.school_city_id"
                                                :validateError="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <ValidationProvider name="highschool_district" rules="" v-slot="{ errors }">
                            <b-form-group :label="$t('district')">
                                <district-outline-selectbox v-model="formData.school_district_id"
                                                            :city_id="formData.school_city_id"
                                                            :validateError="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <ValidationProvider name="class" rules="" v-slot="{ errors }">
                            <b-form-group :label="$t('class')">
                                <ParameterSelectbox code="bisep_application.high_school_classes"  v-model="formData.class"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" lg="8">
                        <b-form-group :label="$t('high_school_score')">
                            <ValidationProvider name="school_diploma_point" rules="dynamic_between:0,100" v-slot="{ errors }">
                                <b-form-input v-model="formData.graduation_average"
                                              type="number"
                                              :state="errors[0] ? false : null" />
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                <b-form-text>{{ $t('high_school_score_info') }}</b-form-text>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <div class="d-flex justify-content-center mb-3">
                <processing-button :processing="loading" variant="primary" v-if="updateMode"
                                   :label="$t('save')" @click="updateForm" />
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import CitySelectbox from '@/components/interactive-fields/CitySelectbox'
import DistrictOutlineSelectbox from "@/components/interactive-fields/DistrictOutlineSelectbox"
import ProcessingButton from '@/components/elements/ProcessingButton'
import BisepService from "@/services/BisepService"

export default {
    name: 'ApplicationInformationTab',
    components: {
        ValidationObserver,
        ValidationProvider,
        CitySelectbox,
        DistrictOutlineSelectbox,
        ProcessingButton
    },
    props: {
        formData: {
            type: Object,
            required: true
        },
        updateMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        async updateForm() {
            this.loading = true
            const isValid = await this.$refs.updateFormValidate.validate();
            if (isValid) {
                let data = { ...this.formData };
                if (data.phone) {
                    data.phone = data.phone.replace(/[^\d]/g, '')
                }

                BisepService.update(data, data.id).then(response => {
                    this.$toast.success(this.$t('api.' + response.data.message))
                    this.loading = false
                    this.$emit('updated', true)
                }).catch(e => {
                    this.loading = false
                    this.showErrors(e, this.$refs.updateFormValidate)
                })
            } else {
                this.loading = false
            }
        }
    }
}
</script>
